<div 
class="absolute z-10  right-2.5 md:-right-6  flex justify-center items-center rounded-full text-lg font-serif text-center text-white w-24 h-24 bg-e-orange" 
[style.backgroundColor]="sticker.bg_color ? sticker.bg_color : 'bg-e-orange'"
[ngClass]="{'-top-24 md:-top-9': moveUp, '-top-14 md:-top-6': !moveUp}"
>
  {{ sticker?.title }}
</div>